import React, { useEffect, useState } from "react";

import { useViewportScroll, motion } from "framer-motion";

const About = () => {
  const scrollFactor = 800;
  const { scrollYProgress } = useViewportScroll();

  const [y, setY] = useState(0);

  useEffect(() => {
    if (window.screen.width > 880) {
      window.addEventListener("scroll", () => {
        setY(scrollYProgress.get() * scrollFactor);
      });
    }
  }, []);

  return (
    <div className="about">
      <div className="container-fluid">
        <motion.div className="wrapper center">
          <div className="about-subtitle subtitle">ABOUT ME</div>
          <motion.div
            style={window.screen.width <= 880 ? {} : { y: -y + 100 }}
            className="about-text"
          >
            I am a Software Developer with 4 years of experience building
            scalable products and high-performance UIs. I specialize in React,
            ReScript, and full-stack development spanning frontend systems to
            backend APIs in Rust and AWS, with hands-on experience shipping
            AI-powered features in production.
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default About;
